import * as THREE from "three";
import arrow from '../../assets/3d/arrow_v4.obj'
import {OBJLoader2} from 'three/examples/jsm/loaders/OBJLoader2'
import {addCameraHelper, addGridHelpers, createDebugCamera} from "./timesliceHelpers";
import {matrixFromSimd} from "./matricesFormaters";
import * as TimesliceExample1 from './timesliceExample1'

const loadArrow = () => {
  let techArrowMaterial = new THREE.MeshStandardMaterial({color: 0x08A5B4});
  let userArrowMaterial = new THREE.MeshStandardMaterial({color: 0xEA2557});
  let loader = new OBJLoader2();

  return Promise.resolve(loader.parse(arrow))
    .then(function (obj) {
      obj.traverse(function (child) {
        if (child instanceof THREE.Mesh) {
          child.material = userArrowMaterial;
        }
      });

      return obj
    })
};

const initializeCamera = (scene, camera, transformCameraMatrix, projectionM) => {
  let positionVector = new THREE.Vector3();
  positionVector.setFromMatrixPosition(transformCameraMatrix);

  let scaleVector = new THREE.Vector3();
  scaleVector.setFromMatrixScale(transformCameraMatrix);

  camera.matrixAutoUpdate = false;
  // camera.position.copy(positionVector);
  // camera.rotation.copy(eulerRotation);
  // camera.scale.copy(scaleVector);
  // camera.updateMatrixWorld();
  camera.matrix.copy(transformCameraMatrix)
  camera.updateMatrixWorld(true);
  camera.projectionMatrix.elements = projectionM.elements;
  // camera.updateProjectionMatrix();

  console.log(camera);

  scene.add( camera );
  let directionalLight = new THREE.DirectionalLight( 0xffffff, 0.2);
  camera.add( directionalLight );
  directionalLight.position.set( 0, 0, 40 );
  directionalLight.target = camera;
};

const addAmbientLight = (scene) => {
  let light = new THREE.AmbientLight(0x404040, 6); // soft white light
  scene.add(light);
};

const calculateFitToContainer = (width, height, containerWidth, containerHeight) => {
  let containerAspect = containerWidth/ containerHeight;
  let sceneAspect = width/height;
  let calculatedWidth, calculatedHeight;

  if(containerAspect < sceneAspect) {
    calculatedWidth = containerWidth;
    calculatedHeight = (containerWidth / width) * height
  } else {
    calculatedHeight = containerHeight;
    calculatedWidth = (containerHeight / height) * width
  }
  return {calculatedWidth, calculatedHeight}
};

const initializeTimesliceTest = (width, height, timeslice) => {
  let renderer = new THREE.WebGLRenderer({antialias: true});
  renderer.setPixelRatio( window.devicePixelRatio );
  renderer.setSize(width, height);
  renderer.autoClear = false;

  let scene = new THREE.Scene();
  let camera = new THREE.PerspectiveCamera();
  timeslice.appendChild(renderer.domElement);

  addGridHelpers(scene);
  addCameraHelper(scene, camera);

  let {debugCamera, debugControls} = createDebugCamera(scene, renderer, width , height);

  let projectionM = matrixFromSimd(TimesliceExample1.projectionMatrix);
  let transformCameraMatrix = matrixFromSimd(TimesliceExample1.transformCameraMatrix);

  initializeCamera(scene, camera, transformCameraMatrix, projectionM);
  addAmbientLight(scene);

  return {renderer, camera, scene, debugCamera, debugControls}
};

const initializeTimeslice = ({width, height, projectionCameraMatrix, transformCameraMatrix}, timeslice) => {
  let containerWidth = timeslice.offsetWidth;
  let containerHeight = timeslice.offsetHeight;

  let {calculatedWidth, calculatedHeight} = calculateFitToContainer(width, height, containerWidth, containerHeight);

  let renderer = new THREE.WebGLRenderer({antialias: true, preserveDrawingBuffer: true});
  renderer.setPixelRatio( window.devicePixelRatio );
  renderer.setSize(calculatedWidth, calculatedHeight);
  renderer.autoClear = false;

  let scene = new THREE.Scene();
  let camera = new THREE.PerspectiveCamera();
  timeslice.appendChild(renderer.domElement);

  // addGridHelpers(scene);
  // addCameraHelper(scene, camera);

  let {debugCamera, debugControls} = createDebugCamera(scene, renderer, calculatedWidth, calculatedHeight);

  let projectionM = matrixFromSimd(projectionCameraMatrix);
  let transformCameraM = matrixFromSimd(transformCameraMatrix);

  initializeCamera(scene, camera, transformCameraM, projectionM);
  addAmbientLight(scene);

  return {renderer, camera, scene, debugCamera, debugControls}
};

const getNumberOfArrowsInArray = (list) => {
  return list.reduce((numArrows, obj) => {
    if(obj instanceof THREE.Mesh) {
      return numArrows
    }
    return numArrows + 1
  }, 0);
};

const addPendingObjectToScene = (scene, drawScene, objects) => {
  objects.forEach(obj => {
    if(obj instanceof THREE.Mesh) {
      drawScene.add(obj)
    } else {
      scene.add(obj)
    }
  })
}

export {
  loadArrow,
  initializeCamera,
  initializeTimeslice,
  addAmbientLight,
  initializeTimesliceTest,
  getNumberOfArrowsInArray,
  addPendingObjectToScene
}
